// extracted by mini-css-extract-plugin
export var closeButton = "_9q-2";
export var expandedImage = "_9q-1";
export var overlay = "_9q-0";